const compatibleJump = (url, target) => {
  const a = document.createElement("a");
  a.href = url;
  a.target = target;
  a.click();
};
export {
  compatibleJump
};
//# sourceMappingURL=CompatibleJump.js.map
